// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"rented_wrapper__1FosT"};